import GroupForm from '../../components/GroupForm';
import AgeGroupLabel from '../../components/AgeGroupLabel';
import TableEditor from '../../components/TableEditor';
import { Table } from '../../components';
import { createOrmActions, editorPropTypes } from '../../components/common';

import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';

const GroupsEditorHeader = ({ children }) => (
  <Table.Row>
    <Table.HeaderCell>Age group</Table.HeaderCell>
    <Table.HeaderCell>Bodyweight category</Table.HeaderCell>
    <Table.HeaderCell width={2}>Group</Table.HeaderCell>
    <Table.HeaderCell width={2}>Entries</Table.HeaderCell>
    {children}
  </Table.Row>
);

const GroupsEditorRow = ({ row, children }) => (
  <Table.Row warning={!row.entries.length}>
    <Table.Cell>
      <AgeGroupLabel ageGroup={row.contest.ageGroup} size="small" />
    </Table.Cell>
    <Table.Cell>{row.contest.bodyweightCategory.title}</Table.Cell>
    <Table.Cell>{row.letter}</Table.Cell>
    <Table.Cell>
      {row.entries.length}
      {row.entries.length !== row.contest.entries.length && (
        <small> ( of {row.contest.entries.length})</small>
      )}
    </Table.Cell>
    {children}
  </Table.Row>
);

const GroupsEditor = ({ groups, actions, meta, ...editorProps }) => {
  const defaultValues = {};

  const rows = orderBy(groups, ['letter', 'order'], ['desc', 'asc']).map(
    group => ({
      ...group,
      key: group.primaryKey,
      description: `group ${group.contest.title}${group.letter}`,
      currentValues: group.serialized,
    }),
  );

  return (
    <TableEditor
      Header={GroupsEditorHeader}
      Row={GroupsEditorRow}
      rows={rows}
      Form={GroupForm}
      defaultValues={defaultValues}
      actions={createOrmActions(actions, rows)}
      meta={meta}
      {...editorProps}
    />
  );
};

GroupsEditor.propTypes = {
  ...editorPropTypes,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default GroupsEditor;



// WEBPACK FOOTER //
// ./src/pages/Schedule/GroupsEditor.js